module.exports = __webpack_public_path__ + "img/no-user-image.ca9900a3.jpg";